<template>
  <div>
    <el-dialog
        :title="'Chọn khoản lập hóa đơn học phí: ' + titleInfoAdd"
        :visible.sync="isOpenSelectRevenueByClassDialog"
        :empty-text="textTable"
        width="1200px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="1vh"
    >

      <el-table
          ref="multipleTable"
          :empty-text="textTable"
          highlight-current-row
          :data="listPayment"
          :cell-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
          :max-height="320"
          @selection-change="handleSelectionChange"
          border
      >
        <el-table-column
            type="selection"
            width="55"
            align="center"
        ></el-table-column>
        <el-table-column
            type="index"
            fixed
            label="STT"
            width="80"
            align="center"
        ></el-table-column>
        <el-table-column
            label="Tên khoản"
            prop="fnPackage.name"
            min-width="180"
            align="left"
        >
          <template v-slot:default="scope">
            <span>{{ scope.row.nameKt }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Số lượng" align="center" width="100">
          <template v-slot:default="scope">
            <span>{{ formatQuantity(scope.row.quantityKt) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Đơn giá" align="right" width="150">
          <template v-slot:default="scope">
            <span>{{ scope.row.priceKt | formatCurrency }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Giảm giá" align="right" width="150">
          <template v-slot:default="scope">
            <span>{{ scope.row.discountKt | formatCurrency }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Thành tiền" align="right" width="150">
          <template v-slot:default="scope">
            <span>{{ scope.row.moneyKt | formatCurrency }}</span>
          </template>
        </el-table-column>
      </el-table>
      <br/>

      <span slot="footer" class="dialog-footer">
        <el-button
            type="primary"
            size="medium"
            :loading="loadingButton"
            mini
            @click="submitForm()"
        >
          <i class="el-icon-circle-check"/>
          <span>Tiếp tục</span>
        </el-button>

        <el-button type="danger" size="medium" @click="closeDialog()">
          <i class="el-icon-circle-close"/>
          <span>{{ $t("button.close") }}</span>
        </el-button>
      </span>
    </el-dialog>

    <!-- Invoice create dialog -->
    <InvoiceCreateDialog
      :invoicePurpose="invoicePurpose"
      :isOpenInvoiceCreateDialog.sync="isOpenInvoiceCreateDialog"
      :initialItems="invoiceInitialItems"
      :kidCode="kidCode"
      :orderKidCode="orderKidCode"
      @invoice-created="handleInvoiceCreated"
      @dialog-close="isOpenInvoiceCreateDialog = false"
    />

  </div>
</template>

<script>

import financeKidsV2Service from "@/services/Finance_Kids_V2/FinanceKidsV2Service";
import InvoiceCreateDialog from "@/components/sinvoice_viettel/dialog/InvoiceCreateDialog.vue";
import moment from "moment";

export default  {
  name: "SelectRevenueByClassDialog",

  components: {
    InvoiceCreateDialog
  },
  // eslint-disable-next-line vue/no-unused-components
  props: {
    isOpenSelectRevenueByClassDialog: {
      type: Boolean,
      default: () => false,
    },
    isActivatedAccount: {
      type: Boolean,
      default: () => false,
    },
  },
  // no computed properties needed
  computed: {},
  data() {
    return {
      invoicePurpose: "ONEKIDS_ORDER",
      selectAllEnabled: true,
      previewBillParams: {
        guiId: "success",
        date: "",
        idKidList: "", // tham số này chỉ truyền vào 1 id thay vì list id
        collectionTurn: "",
      },
      textTable: this.$tableEmpty,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },


      titleInfoAdd: "",
      date: "",
      moneyPayment: 0,
      multipleSelection: "",

      /**
       * Data nhận từ cha
       */

      kidCode: "",
      collectionTurn: 0,
      month: 0,
      year: 0,
      activeStatus: Boolean,

      /**
       * Bắt đầu
       */
      isCheckbox: Array.from({length: 20}, () => true),
      checkAll: true,

      /**
       * Data hiển thị trong bảng
       */

      listPayment: [],
      afterMoney: 0,
      beforeMoney: 0,
      sumMoney: 0,
      collectedMoney: 0,
      moneyCheckTotal: 0,
      transactionEntry: "",
      checkStatus: Boolean,
      activePackageStatus: Boolean,
      urlOnlinePayment: null,
      /**
       * Data gửi về để lưu lịch sử thanh toán
       */

      dataInput: {
        idKids: Number,
        collectionTurn: 0,
        collectedMoney: 0,
        cash_money: 0,
        transfer_money: 0,
        afterMoney: 0,
        paymentType: null,
        parentPay: "PHHS",
        date: "",
        datePayment: moment(String(new Date())).format("YYYY-MM-DD"),
        noteHistory: null,
        transferMoneyType: "MONEY_WALLET",
        statusSendNotify: false
      },

      cashMoney: 0,
      transferMoney: 0,
      afterMoneyThisMonth: 0,
      noteHistory: "",
      responseData: {},
      // invoice dialog control
      isOpenInvoiceCreateDialog: false,
      invoiceInitialItems: [],
      loadingButton: false,
      orderKidCode: "",
      rules: {
        cash_money: [
          {
            required: true,
            message: "Tiền mặt không được để trống!",
            trigger: "blur",
          },
        ],

        transfer_money: [
          {
            required: true,
            message: "Tiền chuyển khoản không được để trống!",
            trigger: "blur",
          },
        ],
        parentPay: [
          {required: true, message: 'Phụ huynh học sinh không được để trống!', trigger: 'blur'},
        ],
      },
    };
  },

  methods: {

    calculateTotalMoney() {
      this.moneyCheckTotal = this.isCheckbox.reduce((total, isChecked, index) => {
        if (isChecked) {
          return total + this.listPayment[index].moneyKt;
        } else {
          return total;
        }
      }, 0);
    },

    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    tableRowStyle({row}) {
      if (row.paid === 0) {
        return "color: #F56C6C";
      } else if (row.paid < row.money) {
        return "color: #E6A23C";
      }
    },

    clearData() {
      this.loadingButton = false;
      this.listPayment = [];
      this.afterMoney = 0;
      this.beforeMoney = 0;
      this.sumMoney = 0;
      this.collectedMoney = 0;
      this.moneyCheckTotal = 0;
      this.isCheckbox = [];
      this.cashMoney = 0;
      this.transferMoney = 0;
      this.afterMoneyThisMonth = 0;
      this.noteHistory = "";
      this.transactionEntry = "";
    },

    /**
     * Đóng Dialog
     */

    closeDialog() {
      this.$emit("dialog-close", this.responseData);
      this.checkAll = true;
      setTimeout(() => {
        this.clearData();
      }, 300);
    },

    reloadMethod() {
      // setTimeout(() => {
      // location.reload();
      // }, 6000);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    /**
     * Nhận dữ liệu từ cha, khởi tạo dữ liệu hiển thị ra màn hình
     *
     * @param idKid - id học sinh
     * @param kidCode - mã của học sinh
     * @param kidName - họ và tên học sinh
     * @param month - tháng của hoá đơn
     * @param collectionTurn - đợt thu của hoá đơn
     * @param orderKidCode - mã hoá đơn
     * @param year - năm của hoá đơn
     * @param activeStatus - tài khoản đã active không
     */
    getDataCashierInitial(
        idKid,
        kidCode,
        kidName,
        month,
        collectionTurn,
        orderKidCode,
        year,
        activeStatus,
    ) {


      // tham số in hơnóa đơn
      this.previewBillParams.date = this.$funcCommon.formatMY(year, month);
      this.previewBillParams.collectionTurn = collectionTurn;
      this.previewBillParams.idKidList = idKid;
      // thông tin lên màn hình
      this.titleInfoAdd = kidName + " - " + orderKidCode + " - D" + collectionTurn;
      this.dataInput.idKids = idKid;
      this.dataInput.collectionTurn = collectionTurn;
      this.kidCode = kidCode;
      this.collectionTurn = collectionTurn;
      this.month = month;
      this.year = year;
      this.activeStatus = activeStatus;
      this.orderKidCode = orderKidCode

      if (month < 10) {
        this.dataInput.date = year + "-0" + month + "-15";
      } else {
        this.dataInput.date = year + "-" + month + "-15";
      }
      financeKidsV2Service
          .showAllPaymentForKid(kidCode, collectionTurn, month, year)
          .then((res) => {
            this.listPayment = res.data.paymentDetails;
            this.$refs.multipleTable.toggleAllSelection()
            this.afterMoney = res.data.afterMoney;
            this.sumMoney = res.data.sumMoney;
            this.collectedMoney = res.data.collectedMoney;
            this.dataInput.transferMoneyType = res.data.transferMoneyType;
            this.beforeMoney = res.data.beforeMoney;
            this.activePackageStatus = res.data.activeStatus;
            this.checkStatus = res.data.checkStatus;
            this.isCheckbox = Array.from({length: this.listPayment.length}, () => true);
            this.afterMoneyThisMonth = this.dataInput.cash_money + this.dataInput.transfer_money + this.afterMoney;
            this.urlOnlinePayment = res.data.urlOnlinePayment;
          })
          .catch(() => {
            this.$message({
              message: "Thất bại",
              type: "error",
            });
          });
    },

    formatQuantity(value) {
      if (value === undefined || value === null || value === '') return '--';
      const num = Number(value);
      if (!Number.isFinite(num)) return '--';
      return Number(num.toFixed(2)).toString();
    },

    submitForm() {
      // Nếu không có mục nào được chọn thì cảnh báo
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message({type: 'warning', message: 'Vui lòng chọn ít nhất một khoản để tiếp tục'});
        return;
      }

      // Chuẩn hóa payload gửi lên parent
      const payload = this.multipleSelection.map(row => {
        const qty = row.quantityKt !== undefined && row.quantityKt !== null && String(row.quantityKt).trim() !== ''
          ? Number(row.quantityKt)
          : (row.quantity !== undefined && row.quantity !== null && String(row.quantity).trim() !== '' ? Number(row.quantity) : 1);
        const price = row.priceKt !== undefined && row.priceKt !== null
          ? Number(row.priceKt)
          : (row.price !== undefined && row.price !== null ? Number(row.price) : 0);
        return {
          id: row.id,
          nameKt: row.nameKt || (row.fnPackage && row.fnPackage.name) || '',
          quantityKt: qty,
          priceKt: price,
          discountKt: Number(row.discountKt) || 0,
          moneyKt: row.moneyKt !== undefined && row.moneyKt !== null ? Number(row.moneyKt) : (qty * price),
          raw: row
        };
      });

      // Emit sự kiện chứa các khoản đã chọn (backwards compatibility)
      this.$emit('select-revenue-continue', payload);

      // Mở InvoiceCreateDialog ngay trong component này, truyền payload
      this.invoiceInitialItems = payload;
      this.isOpenInvoiceCreateDialog = true;
    },
    handleInvoiceCreated(payload) {
      this.$emit('invoice-created', payload);
      this.isOpenInvoiceCreateDialog = false;
      this.$emit("dialog-close", this.responseData);
      this.checkAll = true;
      setTimeout(() => {
        this.clearData();
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  word-break: break-word;
}

/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

/deep/
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-dialog__body {
  padding-bottom: 5px;
}

/deep/ .el-form-item__label {
  color: black;
}

.el-row {
  margin-top: 15px;
  padding-top: 20px;
  background: #97bee7;
  color: black;
  border-radius: 5px;
}

.input-common {
  margin-right: 5px;
}

.text-money {
  margin-bottom: 15px;
}

/deep/ .el-form-item__content {
  line-height: 0;
}

/deep/ .negative-value .el-input__inner {
  color: red;
}
</style>